/**
 * Valida se há sobreposição entre intervalos de posições
 * @param {Array} ranges - Array de objetos com positionStart e positionEnd
 * @returns {string|null} - Mensagem de erro se houver sobreposição, null caso contrário
 */
export const validateNoOverlap = (ranges) => {
  const validRanges = ranges.filter(
    (r) => r && r.positionStart && r.positionEnd
  );

  for (let i = 0; i < validRanges.length; i++) {
    const start1 = parseInt(validRanges[i].positionStart, 10);
    const end1 = parseInt(validRanges[i].positionEnd, 10);

    for (let j = i + 1; j < validRanges.length; j++) {
      const start2 = parseInt(validRanges[j].positionStart, 10);
      const end2 = parseInt(validRanges[j].positionEnd, 10);

      if (
        (start1 <= end2 && end1 >= start2) ||
        (start2 <= end1 && end2 >= start1)
      ) {
        return `Sobreposição detectada entre intervalos: [${start1}-${end1}] e [${start2}-${end2}]`;
      }
    }
  }

  return null;
};

/**
 * Calcula o total de posições configuradas (soma dos intervalos)
 * @param {Array} ranges - Array de objetos com positionStart e positionEnd
 * @returns {number} - Total de posições configuradas
 */
export const calculateConfiguredPositions = (ranges) => {
  return ranges.reduce((total, range) => {
    if (range && range.positionStart && range.positionEnd) {
      const start = parseInt(range.positionStart, 10);
      const end = parseInt(range.positionEnd, 10);

      if (!isNaN(start) && !isNaN(end) && start <= end) {
        return total + (end - start + 1);
      }
    }
    return total;
  }, 0);
};

/**
 * Verifica se uma posição está dentro de algum intervalo configurado
 * @param {number} position - Posição a verificar
 * @param {Array} ranges - Array de intervalos
 * @returns {boolean} - true se a posição está em algum intervalo
 */
export const isPositionInRange = (position, ranges) => {
  return ranges.some((range) => {
    const start = parseInt(range.positionStart, 10);
    const end = parseInt(range.positionEnd, 10);

    return !isNaN(start) && !isNaN(end) && position >= start && position <= end;
  });
};